import { Table } from 'legacy/lut/library/list'
import { useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { ICheckedValue } from 'core-components/library/list/types'
import { selectRounding } from 'partner360/features/QBR'
import { IQbrDocumentInitiative } from 'partner360/models/qbr/iQbrDocumentInitiative'

import { TRANSLATION_KEYS } from '../../../../translations'

import { getDialogContentColumns } from './helpers/getDialogContentColumns'
import { IInitiativesDialogContentProps } from './models/iInitiativesDialogContentProps'

import styles from './InitiativesDialogContent.module.scss'

export const InitiativesDialogContent = ({ dataSource, onAdd }: IInitiativesDialogContentProps) => {
  const [checkedInitiatives, setCheckedInitiatives] = useState<IQbrDocumentInitiative[]>([])
  const [checkedItems, setCheckedItems] = useState<ICheckedValue[]>([])
  const rounding = useSelector(selectRounding)

  const columns = useMemo(() => getDialogContentColumns(rounding), [rounding])

  const handleCheckInitiative = useCallback(
    (initiative: IQbrDocumentInitiative, isChecked: boolean) => {
      if (isChecked) {
        setCheckedInitiatives((prevState) => [...prevState, initiative])
        setCheckedItems((prevState) => [
          ...prevState,
          {
            value: 'full',
            key: initiative.EntryId,
          },
        ])
      } else {
        setCheckedInitiatives((prevState) =>
          prevState.filter((it) => it.EntryId !== initiative.EntryId)
        )
        setCheckedItems((prevState) => prevState.filter((it) => it.key !== initiative.EntryId))
      }
    },
    []
  )

  const handleAddInitiatives = useCallback(() => {
    onAdd(checkedInitiatives)
  }, [checkedInitiatives, onAdd])

  return (
    <div className={styles.root}>
      <Table
        header
        useRowCheckbox
        pagination
        hasTranslate
        onCheck={handleCheckInitiative}
        checkedValues={checkedItems}
        columns={columns}
        source={dataSource}
      />
      <div className={styles.actionsButtons}>
        <Button
          disabled={checkedItems.length === 0}
          onClick={handleAddInitiatives}
          className={styles.addButton}
        >
          <Translation text={TRANSLATION_KEYS.initiativesDialog.addInitiativesButton} />
        </Button>
      </div>
    </div>
  )
}
